module.exports = __webpack_public_path__ + "media/klaseaDia2Barco1.554e34e0.mp4";